import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import Loader from "@/components/Loader";
import { Download } from "lucide-react";

const BADGE = { captured: "bg-green-100 text-green-700", manual: "bg-purple-100 text-purple-700", created: "bg-amber-100 text-amber-700", failed: "bg-red-100 text-red-700" };

export default function AdminPayments() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/admin/payments").then(({ data }) => setRows(data.payments || []));
  }, []);

  const fmt = (iso) => { try { return iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"; } catch { return "—"; } };

  if (rows === null) return <Loader />;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="text-2xl md:text-3xl font-heading font-extrabold">Payments</h1>
        <a href={`${API}/admin/payments/export`} className="btn-ghost text-sm" data-testid="pay-export"><Download className="w-4 h-4" /> Export Excel</a>
      </div>
      <div className="card-thali overflow-x-auto p-0" data-testid="pay-table">
        <table className="w-full text-sm min-w-[760px]">
          <thead><tr className="bg-thali-cream text-thali-ink/70">
            <th className="text-left p-2 pl-4">User</th><th className="p-2">Payment ID</th><th className="p-2">Order ID</th>
            <th className="p-2">Amount</th><th className="p-2">Status</th><th className="p-2">Source</th><th className="p-2 pr-4">Date</th>
          </tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="border-t border-thali-turmeric/10" data-testid={`pay-row-${p.id}`}>
                <td className="p-2 pl-4"><div className="font-medium">{p.user_name}</div><div className="text-xs text-thali-ink/50">{p.mobile}</div></td>
                <td className="p-2 text-center text-xs break-all">{p.payment_id || "—"}</td>
                <td className="p-2 text-center text-xs break-all">{p.order_id || "—"}</td>
                <td className="p-2 text-center font-num font-bold">₹{p.amount}</td>
                <td className="p-2 text-center"><span className={`text-xs px-2 py-0.5 rounded-full font-bold ${BADGE[p.status] || "bg-gray-100"}`}>{p.status}</span></td>
                <td className="p-2 text-center text-xs">{p.source}</td>
                <td className="p-2 pr-4 text-center text-xs">{fmt(p.created_at)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-thali-ink/50">No payments yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
